import axios from "@axios";
import store from "@/store";

export default {
  namespaced: true,
  state: {
    items: [],
    allItems: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((alarm_level) => ({
        value: alarm_level.id,
        label: alarm_level.level,
      }));
    },
    getSelectedItemsWithNames(state) {
      return state.items.map((alarm_level) => ({
        value: alarm_level.id,
        label: alarm_level.description,
      }));
    },
    getAllItems(state) {
      return state.allItems
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
    setAllItems(state, value) {
      state.allItems = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const response = await axios.get("v1/alarm_level", {
        params,
        responseType: params?.action === "export" ? "blob" : "json",
      });

      if (!response.data) {
        return [];
      }

      if (params?.action === "export") {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );
        document.body.appendChild(link);
        link.click();
        link.remove();

        const notification = {
          id: response.headers["content-disposition"].split("filename=")[1],
          progress: 100,
          completed: true,
          view: "alarm-level",
          url: url,
          download: response.headers["content-disposition"].split("filename=")[1],
          title: "Reporte de nivel de alarma",
          body: "Descarga completa",
          error: false,
          timestamp:
            new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };
        store.dispatch("grid/updateDownloadNotification", notification);
      } else {
        commit("setData", response.data.data);
        return response.data;
      }
    },
    async add(_, params) {
      const { data } = await axios.post("v1/alarm_level", params, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return data;
    },
    async edit(_, { id, params }) {
      const { data } = await axios.post(`v1/alarm_level/${id}?_method=put`, params, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return data;
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/alarm_level/${id}`);

      return data;
    },
    async getAllUnpaginated({ commit }) {
      const response = await axios.get('v1/alarm_level')

      if (!response.data?.data) {
        return []
      }

      const filteredItems = response.data.data.map(item => ({
        id: item.id,
        description: item.description,
        color: item.color,
        border_color: item.border_color,
        alarmTypes: item.alarmTypes
          ? item.alarmTypes.map((aT) => ({id: aT.id, type: aT.type, acronym: aT.acronym}))
          : [],
      }))

      commit('setAllItems', filteredItems)
      return filteredItems
    },
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
